export default "__VITE_ASSET__7xr8WPTl__"